import ZdWpCustom from '../util/Custom';
import Circular from '../util/Circular';
import Fontawesome from '../util/Fontawesome';
import WpBackeryBS4 from '../util/WpBackeryBS4';

export default {
  // namespace
  __NS__: 'ZD',
  init() {
    // JavaScript to be fired on all pages
    if (!window.wp) {
      window.wp = {};
    }

    // ZdWpCustom
    this.ZdWpCustom = new ZdWpCustom();

    // VisualComposer
    this.WpBackeryBS4 = new WpBackeryBS4();

    // Turbolinks
    // if ('localhost' !== document.location.hostname) {
    //   var Turbolinks = require("turbolinks");
    //   Turbolinks.start();
    // }

    // Circular
    window.wp.Circular = new Circular();

    // Fontawesome
    this.Fontawesome = new Fontawesome();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    window.wp.Circular.finalize();

    this.ZdWpCustom.finalize();
  },
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/common.js